export const SET_LOADING = "SET_LOADING";

export function setLoadingMaskStatus(loading, msg = null) {
  return {
    type: SET_LOADING,
    loading,
    msg,
  };
}
